import React, { useCallback } from 'react';

import { Select } from 'components/DesignSystem/Select';
import { InputOption } from 'components/DesignSystem/Select/components/InputOption/InputOption';
import { ValueContainer } from 'components/DesignSystem/Select/components/ValueContainer/ValueContainer';
import { TextInput } from 'components/DesignSystem/TextInput/TextInput';
import classes from 'components/widgets/Recommendations/recommendations.module.scss';
import { TSeverity } from 'components/widgets/Recommendations/recommendationsTable';

const severityOptions: ISelectOption<TSeverity>[] = [
    { value: 'High', label: 'High' },
    { value: 'Medium', label: 'Medium' },
    { value: 'Low', label: 'Low' },
];

export const Filters = ({ handleStatus, chosenFilter, search, handleSearch, handleClearSearch, handleOnSearch }) => {
    const onKeyDown = useCallback(
        (e: React.KeyboardEvent<HTMLInputElement>) => {
            if (e.code === 'Enter' || e.code === 'NumpadEnter') {
                handleOnSearch();
            }
        },
        [search],
    );

    return (
        <div className={classes.filterWrapper}>
            <div className={classes.selectWrapper}>
                <div className={classes.title}>Title</div>
                <TextInput
                    placeholder={'Search Recommendations'}
                    value={search}
                    onChange={handleSearch}
                    onClear={handleClearSearch}
                    maxLength={30}
                    onKeyDown={onKeyDown}
                    className={classes.inputText}
                    searchable={true}
                    onSearch={handleOnSearch}
                />
            </div>
            <div className={classes.selectWrapper}>
                <div className={classes.title}>Severity</div>
                <div className={classes.filterItemResults}>
                    <Select<ISelectOption<TSeverity>, true>
                        value={chosenFilter.severity}
                        options={severityOptions}
                        onChange={(value) => handleStatus(value, 'severity')}
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        isMulti={true}
                        placeholder={'Select Severity...'}
                        components={{
                            Option: InputOption,
                            ValueContainer: ValueContainer,
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
